import moment from "moment-timezone";

export const tz = moment.tz.guess();
export const sourceTz = "America/Los_Angeles";
